import {
  REQUEST_PLACEMENT,
  RECEIVE_PLACEMENT,
  UPDATE_PLACEMENT,
  PLACEMENT_UPDATED,
  PLACEMENT_FAILED,
  REQUEST_CLONE_PLACEMENT,
  BEGIN_NEW_PLACEMENT,
  RECEIVE_CLONE_PLACEMENT,
  CLONE_PLACEMENT_FAILED,
  CLONE_PLACEMENTS_FAILED,
  REQUEST_CLONE_PLACEMENTS,
  RECEIVE_CLONE_PLACEMENTS,
  REQUEST_PUSH_PLACEMENTS,
  RECEIVE_PUSH_PLACEMENTS,
  PUSH_FAILED,
  RECEIVE_FIX_PLACEMENTS,
  SET_EDIT_PLACEMENTS,
  GO_TO_PLACEMENT,
  RESET_CLONE_PLACEMENT_STATE,
  COPY_SETTINGS,
  RECEIVE_COPIED_SETTINGS,
  COPY_SETTINGS_FAILED,
  FIX_FAILED,
  BULK_PLACEMENTS_FAILED
} from '../actions/types';

export const placementRequest = (state = {}, action) => {
  switch(action.type) {
    case RECEIVE_PLACEMENT:
      return Object.assign({}, state, {
        isFetching: false,
        placement: action.placement,
        error: null
      });
    case REQUEST_PLACEMENT:
      return Object.assign({}, state, {
        isFetching: true,
        placement: {},
        error: null
      });
    case UPDATE_PLACEMENT: // to do
      return Object.assign({}, state, {
        isFetching: true,
        placement: {},
        error: null
      });
    case PLACEMENT_UPDATED:
      return Object.assign({}, state, {
        isFetching: false,
        placement: action.placement,
        error: null
      });
    case PLACEMENT_FAILED:
      return Object.assign({}, state, {
        isFetching: false,
        placement: {},
        error: action.error
      });
    case REQUEST_CLONE_PLACEMENTS:
    case REQUEST_CLONE_PLACEMENT:
      return Object.assign({}, state, {
        isCloning: true,
        cloneRequest: action.payload,
        clonedPlacements: {},
        error: null
      });
    case RECEIVE_CLONE_PLACEMENTS:
      return Object.assign({}, state, {
        isCloning: false,
        clonedPlacements: action.payload.cloned,
        updatedPlacements: action.payload.updated
      });
    case RECEIVE_CLONE_PLACEMENT:
      return Object.assign({}, state, {
        isCloning: false,
        clonedPlacements: action.payload
      });
    case CLONE_PLACEMENTS_FAILED:
    case CLONE_PLACEMENT_FAILED:
      return Object.assign({}, state, {
        isCloning: false,
        cloneError: action.error,
        clonedPlacements: null,
        error: action.error
      });
    case REQUEST_PUSH_PLACEMENTS:
      return Object.assign({}, state, {
        isPushing: true,
        pushRequest: action.payload,
        pushResult: {},
        pushError: null
      });
    case RECEIVE_PUSH_PLACEMENTS:
      return Object.assign({}, state, {
        isPushing: false,
        pushResult: action.payload
      });
    case PUSH_FAILED:
      return Object.assign({}, state, {
        isPushing: false,
        pushError: action.error,
        pushResult: null,
        error: action.error
      });
    case RECEIVE_FIX_PLACEMENTS:
      return Object.assign({}, state, {
        fixResult: action.payload
      });
    case RESET_CLONE_PLACEMENT_STATE:
      return Object.assign({}, state, {
        isCloning: false,
        error: null,
        clonedPlacements: {}
      });
    case BEGIN_NEW_PLACEMENT:
      return Object.assign({}, state, {
        isFetching: false,
        placement: {}
      });
    case RECEIVE_COPIED_SETTINGS:
      return Object.assign({}, state, {
        error: null
      });
    case COPY_SETTINGS:
      return Object.assign({}, state, {
        error: null
      });
    case COPY_SETTINGS_FAILED:
    case FIX_FAILED:
    case BULK_PLACEMENTS_FAILED:
      return Object.assign({}, state, {
        isFetching: false,
        error: action.error
      });
    default: {
      return state;
    }
  }
};

export const selectedPlacements = (state = {}, action) => {
  switch(action.type) {
    case SET_EDIT_PLACEMENTS:
      return Object.assign({}, state, {
        editList: action.ids,
        current: 0
      });
    case GO_TO_PLACEMENT:
      return Object.assign({}, state, {
        current: action.value
      });
      default: {
      return state;
    }
  }
};
